import React from "react";
import {
  formatDateTime,
  formatPrice,
  formatRefundMethod,
  formatPoint,
  formatRefundStatus,
} from "../../../../utils";

const RefundInformation = ({ cancellationRefundInformation }) => {
  return (
    <div className="mt-4">
      <div>
        <p className="text-sm font-bold mt-3">주문취소 환불 정보</p>

        {cancellationRefundInformation?.map((data, index) => {
          return (
            <table className="table-fixed min-w-full mt-8" key={index}>
              <tbody>
                <tr>
                  <td className="border border-disable-grey bg-input-grey w-32 p-2">
                    취소승인 일시(본사)
                  </td>
                  <td colSpan={3} className="border border-disable-grey p-2">
                    {formatDateTime(data?.approvedAt)}
                  </td>
                </tr>
                <tr>
                  <td className="border border-disable-grey bg-input-grey w-32 p-2">
                    주문취소 상품명
                  </td>
                  <td colSpan={3} className="border border-disable-grey p-2">
                    {data?.productName}
                  </td>
                </tr>
                <tr>
                  <td className="border border-disable-grey bg-input-grey w-32 p-2">
                    주문취소 예정 금액
                  </td>
                  <td colSpan={3} className="border border-disable-grey p-2">
                    {formatPrice(data?.amountCanceled)}원
                  </td>
                </tr>
                <tr>
                  <td className="border border-disable-grey bg-input-grey w-32 p-2">
                    환불상태
                  </td>
                  <td colSpan={3} className="border border-disable-grey p-2">
                    {/*  주문취소 환불완료 (신용카드), 반품 환불완료 (신용카드) */}
                    {formatRefundStatus(data?.refundStatus)}
                  </td>
                </tr>
                <tr>
                  <td className="border border-disable-grey bg-input-grey w-32 p-2">
                    환불수단
                  </td>
                  <td colSpan={3} className="border border-disable-grey p-2">
                    {formatRefundMethod(data?.refundMethod)}
                  </td>
                </tr>
                <tr>
                  <td className="border border-disable-grey bg-input-grey w-32 p-2">
                    환불정보
                  </td>
                  <td colSpan={3} className="border border-disable-grey p-2">
                    {data?.refundInformation}
                  </td>
                </tr>
                <tr>
                  <td className="border border-disable-grey bg-input-grey w-32 p-2">
                    환불일시(입금)
                  </td>
                  <td colSpan={3} className="border border-disable-grey p-2">
                    {formatDateTime(data?.refundAt)}
                  </td>
                </tr>
                <tr>
                  <td className="border border-disable-grey bg-input-grey w-32 p-2">
                    환불금액
                  </td>
                  <td
                    colSpan={3}
                    className="border border-disable-grey p-2 text-input-red"
                  >
                    {formatPrice(Math.round(data?.refundAmount))}원
                  </td>
                </tr>
                <tr>
                  <td className="border border-disable-grey bg-input-grey w-32 p-2">
                    적립 취소 포인트
                  </td>
                  <td
                    colSpan={3}
                    className="border border-disable-grey p-2 text-input-red"
                  >
                    {formatPoint(data?.creditCancellationPoints)}P
                  </td>
                </tr>
                <tr>
                  <td className="border border-disable-grey bg-input-grey w-32 p-2">
                    환불 사용 포인트{" "}
                  </td>
                  <td
                    colSpan={3}
                    className="border border-disable-grey p-2 text-input-red"
                  >
                    {formatPoint(data?.refundRedemptionPoints)}P
                  </td>
                </tr>
              </tbody>
            </table>
          );
        })}
      </div>
    </div>
  );
};

export default RefundInformation;
